<template>
  <header class="header">
    <div class="header-wrapper">
      <div class="header__left">
        <router-link to="/" class="header__logo">
          <header-logo />
        </router-link>
        <region-select />
      </div>

      <header-menu />

      <div v-if="user" class="header__right">
        <report-download />
        <a class="header__login" href="#" @click.prevent="handleLogout">
          {{ user.title }}
          <icon-logout />
        </a>
      </div>
    </div>
  </header>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import HeaderMenu from '@/components/menu/HeaderMenu.vue'
import HeaderLogo from '@/components/images/HeaderLogo.vue'
import ReportDownload from '@/components/ReportDownload.vue'
import IconLogout from '@/components/images/IconLogout.vue'
import RegionSelect from './RegionSelect.vue'
import store from '@/store'

const user = computed(() => store.state.user)

const handleLogout = () => {
  store.logout()
}
</script>
